import type { WritableAtom } from "jotai";
import type { ExtraFieldType } from "./types";
import { useFocusAtom } from "./utils";
import clsx from "clsx";
import * as React from "react";
import NumberFormat from "react-number-format";

export function ExtraField(props: {
  atom: WritableAtom<ExtraFieldType, ExtraFieldType>;
  index: number;
  delete: () => void;
}) {
  const [title, setTitle] = useFocusAtom(props.atom, o => o.prop("title"));
  const [value, setValue] = useFocusAtom(props.atom, o => o.prop("value"));
  return (
    <div
      className={clsx("atc-row", {
        "atc-row--light-bg": props.index % 2 === 1
      })}
    >
      <div className="atc-label">
        <input
          className="atc-label atc-label__title"
          type={"text"}
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <span className="atc-label__text atc-edit-button">click to edit</span>
      </div>
      <NumberFormat
        className="at-input at-input--border"
        thousandSeparator={"."}
        decimalSeparator={","}
        value={value}
        onValueChange={values => {
          const { value } = values;
          setValue(Number(value));
        }}
      />
      <div className="delete" onClick={() => props.delete()}>
        x
      </div>
    </div>
  );
}
